/** The message an API error carries, whatever shape the backend sent it in. */
export function apiErrorMessage(error: any, fallback: string): string {
	const message = error?.response?.data?.message ?? error?.response?.data?.errors;
	if (Array.isArray(message)) return message.join(" ");
	return message || fallback;
}

/** The HTTP status an axios error carries, where it carries one. A 403 is often a real answer. */
export function statusCode(error: unknown): number | undefined {
	return (error as { response?: { status?: number } })?.response?.status;
}

/** Binary units, because the ceilings they are compared against are set in MiB. */
export function formatBytes(bytes: number | null | undefined): string {
	if (bytes === null || bytes === undefined || !Number.isFinite(bytes)) return "—";
	if (bytes < 1024) return `${bytes} B`;

	const units = ["KB", "MB", "GB"];
	let value = bytes / 1024;
	let unit = 0;

	while (value >= 1024 && unit < units.length - 1) {
		value /= 1024;
		unit += 1;
	}

	return `${value.toLocaleString("en-SG", { maximumFractionDigits: 1 })} ${units[unit]}`;
}

export function formatDateTime(value?: string | null): string {
	if (!value) return "—";

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "—";

	return date.toLocaleString("en-GB", {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}
